module.exports = __webpack_public_path__ + "packs/media/images/card_image_1-c08f53c9bfd515421cc5f2240beb2be3.png";